import "./App.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { authProviderMX, authProviderEU } from "./context/authProvider";
import { DynamicAuthProvider } from "./context/AuthProviderContext";

import { Header } from "./components/Header";
import { LoadingPage } from "./pages/LoadingPage";
import { AppWraper } from "./AppWraper";
import { UnAuthenticatedRouter } from "./router/UnAuthenticatedRouter";
import { RoleProvider } from "./context/RoleContext";
import { BrandPreviewProvider } from "./context/BrandPreviewContext";

function App() {
    const location = useLocation();

    const { region, authProvider } = useMemo(() => {
        return { region: 'EU', authProvider: authProviderEU };
    }, [location.search]);

    return (
        <div className="App">
            <DynamicAuthProvider provider={authProvider}>
                <AzureAD provider={authProvider} key={region}>
                    {({ authenticationState, accountInfo, login }) => {
                        let userEmail = null;

                    if (
                        authenticationState === AuthenticationState.Authenticated &&
                        accountInfo &&
                        accountInfo.account
                            ) {
                        userEmail =
                            accountInfo.account.userName || accountInfo.idTokenClaims?.preferred_username;
                        console.log("App.js - User authenticated email:", userEmail);
                    }

                    switch (authenticationState) {
                        case AuthenticationState.Authenticated:
                            return (
                                <RoleProvider authenticatedUserEmail={userEmail}>
                                    <BrandPreviewProvider>
                                        <Header />
                                        <AppWraper />
                                    </BrandPreviewProvider>
                                </RoleProvider>
                            );
                        case AuthenticationState.Unauthenticated:
                            return <UnAuthenticatedRouter login={login}/>;
                        case AuthenticationState.InProgress:
                            return <LoadingPage />;
                        default:
                            return null;
                    }
                }}
            </AzureAD></DynamicAuthProvider>
        </div>
    );
}

export default App;
